import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs/index';
import {SendBackResult} from '../../shared/models/send-back-result';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from '../../shared/services/app-settings.service';
import {BaseRestService} from '../../shared/services/base-rest.service';

@Injectable({providedIn: 'root'})
export class DHLService extends BaseRestService {
  private subject =  new BehaviorSubject<Object>('') ;
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'DHLService'; }
  protected get isAnonymous(): boolean { return false; }

  getRate( data: Object): Observable<SendBackResult<Object>> {
    return this.post<Object>(`/broker/dhl/RateRequest`, data );

  }
  dhlError(resp: object): void { this.subject.next({  resp }); }

  dhlSucces(resp: object): void {
    this.subject.next({ resp });
  }

  getResponse(): Observable<object> {
    return this.subject.asObservable();
  }
}
